import { gql } from '@apollo/client'
import { buildTags, MetaTags } from '@jusbrasil-web/docview/core'

import { MotionMetaTags_DocumentFragment } from './__generated__/motion-meta-tags.graphql'
import { MotionSeoMetadata } from './motion-seo-metadata'

export type MotionMetaTagsProps = {
  document: MotionMetaTags_DocumentFragment
}

export function MotionMetaTags(props: MotionMetaTagsProps) {
  const { document } = props
  const { url } = document
  const seoMetadata = new MotionSeoMetadata(document).getSeoMetadata()
  const tags = buildTags({ document, seoMetadata })

  const robotsMetatag = tags.meta.find((meta) => meta.name === 'robots')
  if (robotsMetatag) {
    robotsMetatag.content = 'noarchive'
  } else {
    tags.meta.push({ name: 'robots', content: 'noarchive' })
  }

  return <MetaTags url={url} tags={tags} />
}

MotionMetaTags.fragments = {
  document: gql`
    fragment MotionMetaTags_document on Document {
      title
      url
      meta
      noIndex
      text(highlight: true)
      subtitle
      lawsuit {
        subjects
        court
      }
      lawsuitNumber

      ...MetaTags_document
    }
    ${MetaTags.fragments.document}
  `,
}
